export enum TypeBrand {
  Tyres = 'Tyres',
  Disks = 'Disks',
  Akb = 'Akb',
  Oils = 'Oils',
  TruckTyres = 'TruckTyres',
}

export interface CarTag {
  title: string;
  href: string;
}

export interface CarsLink {
  title: string;
  tags: CarTag[];
}

export interface CatalogListLink {
  title: string;
  image: string;
  href: string;
  testid?: string;
}

export type brandItem = {
  id: number;
  urlname: string;
  ord: number;
  name: string;
  thumb: string;
};

export interface IKamaContent {
  code: string;
  value: string;
}
export interface IKamaBrand {
  region: number;
  brand: string;
}

export interface IBrandKamaList {
  id: number;
  name: string;
  code: string;
  brandUrl: string;
  brandName: string;
  brand: string;
  thumb: string;
  season: number;
  rating: number;
  price: number;
  qnty: number;
}

export interface BrandSchema {
  brandListTyres?: brandItem[];
  brandListDisks?: brandItem[];
  brandListAkb?: brandItem[];
  brandListOils?: brandItem[];
  brandListTruckTyres?: brandItem[];
  brandKamaContent: IKamaContent;
  brandKumhoContent: IKamaContent;
  brandViattiContent: IKamaContent;
  brandListKama: IBrandKamaList[];
  brandListKumho: IBrandKamaList[];
  brandListViatti: IBrandKamaList[];
}
